import Vue from "vue";
import SvgIcon from "./template.vue";

Vue.component("svg-icon", SvgIcon);

const req = require.context("./svgs", false, /\.svg$/);
const requireAll = (rc) => rc.keys().map(rc);
requireAll(req);
